module.exports = __webpack_public_path__ + "img/xqiu.6b1b606c.png";